import React from "react";
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import browserHistory from "../utils/history";
import {defaultImageSrc} from '../utils/imageUtils';
import {recordVisit} from '../actions/metricsActions';
import {BookNowButton, ItemContainer, ItemTitle, TileContainer, BookNowLabel, PreviewLabel} from '../resources/styles';
import {truncateStringBeforeLastWord} from "../utils/stringUtils";
import ImageWithFallback from "./ImageWithFallback";
import {withTheme} from "styled-components";
import PropTypes from "prop-types";

class ImageButton extends React.Component {

    handleLinkClick = (e, url) => {
        e.preventDefault();

        if(url && url.indexOf("http") === 0) {
            const parsedUrl = new URL(url);
            recordVisit(parsedUrl.href);

            const newWindow = window.open();
            newWindow.opener = null;
            newWindow.location = url;
        }
        else {
            // Prepend url with / if its not starting with http
            browserHistory.push(`${url[0] === "/" ? "" : "/" }${url}`, this.props.linkState);
        }
    };

    recordExternalClick = (e, url) => {
        const parsedUrl = new URL(url);
        recordVisit(parsedUrl.href);
    };

    render() {
        let imageUrl = this.props.thumbnail || defaultImageSrc();

        const bookable = (this.props.bookable && this.props.deviceType !== "DigitalSignage") ? true : false;

        let isExternalUrl = false;
        let url = this.props.link;
        const redirectUrl = this.props.redirectUrl;

        if (redirectUrl && redirectUrl !== "" && this.props.useRedirectUrl !== false) {
            url = redirectUrl;
            if(url.indexOf("http") > -1) {
                isExternalUrl = true;
            }
        }

        const linkContent = (
            <ItemContainer>
                <ImageWithFallback src={imageUrl} alt={this.props.title} />

                {this.props.showTitle !== false &&
                    <ItemTitle
                        textColor={this.props.textColor}
                        backgroundColor={this.props.backgroundColor}
                    >
                        {this.props.truncateTitle ? truncateStringBeforeLastWord(this.props.title, 30) : this.props.title}
                    </ItemTitle>
                }

                {this.props.showBookNow === true && this.props.deviceType !== "DigitalSignage" &&
                    <BookNowLabel>
                        {this.context.t('book_now')}
                    </BookNowLabel>
                }
            </ItemContainer>
        );

        return (
            <TileContainer heightWidthRatio={this.props.heightWidthRatio || this.props.theme.tileHeightWidthRatio || "100%"}>
                {bookable &&
                    <BookNowButton>
                        {this.context.t('book_now')}
                    </BookNowButton>
                }

                {this.props.showPreviewTag && 
                    <PreviewLabel>
                        <i className="fa fa-eye-slash"/>
                    </PreviewLabel>
                }

                {isExternalUrl ?
                    <a href={url} target="_blank"  rel="noopener noreferrer" onClick={(e) => this.recordExternalClick(e, url)}>{linkContent}</a> :
                    <Link to={url} onClick={(e) => this.handleLinkClick(e, url)}>
                        {linkContent}
                    </Link>
                }
            </TileContainer>
        )
    }
}

ImageButton.contextTypes = {
    t: PropTypes.func.isRequired
}

const mapStateToProps = state => {
    return {
        deviceType: state.configuration.hubSettings.deviceType,
        lang: state.i18nState.lang
    };
};

export default connect(mapStateToProps) (withTheme(ImageButton));